// Typelizer digest 29be5ef2a69753f98da0b9e4f40005fc
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /setup/copy_season */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/setup/copy_season', {}, options),
    method: 'post',
  }),
}
